export default __webpack_public_path__ + "routing-800-f2915c98f051eb1d64e5e64d15442007.png";